<template>
  <div class="message-scheduler-container">
    <messages-helper-line
      v-if="!fetchingDataLoader && scheduledMessages.length > 0"
    ></messages-helper-line>
    <messages-container
      :scheduledMessagesProp="scheduledMessages"
      v-if="!fetchingDataLoader && scheduledMessages.length > 0"
    ></messages-container>
    <fetching-loader
      displayType="displayBlock"
      v-if="fetchingDataLoader"
    ></fetching-loader>
    <div
      class="total-multimessage-wrapper"
      v-if="!fetchingDataLoader && scheduledMessages.length == 0"
    >
      <p>No Multimessage has been scheduled</p>
    </div>
  </div>
</template>

<script>
import FetchingLoader from "@/components/GlobalComponents/FetchingLoader";
import MessagesContainer from "./MessageSchedulerComponents/MessagesContainer";
import MessagesHelperLine from "./MessageSchedulerComponents/MessagesHelperLine";
import { firestore } from "@/firebase";

export default {
  components: {
    MessagesContainer,
    MessagesHelperLine,
    FetchingLoader,
  },
  data() {
    return {
      fetchingDataLoader: true,
      scheduledMessages: [],
    };
  },
  created() {
    firestore
      .collection("MultimessageScheduler")
      .doc(`${this.$hotelId}`)
      .collection("ScheduledMessages")
      .orderBy("sendingAt", "asc")
      .get()
      .then((querySnapshot) => {
        this.scheduledMessages = [];
        querySnapshot.forEach((doc) => {
          this.scheduledMessages.push(doc.data());
        });
        this.fetchingDataLoader = false;
      })
      .catch((err) => console.log(err));
  },
};
</script>

<style scoped>
.message-scheduler-container {
  margin: 20px auto 0px;
  padding: 20px 40px;
}

div >>> p {
  margin-bottom: 0;
}

h3 {
  color: #707070;
  font-size: 28px;
  margin-right: 15px;
}
.total-multimessage-wrapper {
  margin-top: 50px;
}
.total-multimessage-wrapper > p {
  font-size: 20px;
}
</style>
